import { useRef } from "react";
import AgGrid from "../../../UI/AgGrid";
import { usePaymentChannelColumnDefs } from "./usePaymentChannelColumnDefs";

type Props = {
  onEditHandler: (id?: number) => void;
  onDeleteHandler: (id?: number) => void;
  data: any[];
};

const PaymentChannelTable = ({
  onEditHandler,
  onDeleteHandler,
  data,
}: Props) => {
  const gridRef = useRef(null);
  const columnDefs = usePaymentChannelColumnDefs(
    onEditHandler,
    onDeleteHandler
  );

  return (
    <AgGrid
      columnDefs={columnDefs}
      ref={gridRef}
      rowData={data || []}
      height={650}
      disabledSidebar
    />
  );
};

export default PaymentChannelTable;
